export default class CompanyDocModel {
  constructor() {
    this.docId = '';
    this.category = '';
    this.department = '';
    this.noDocReason = '';
    this.invoiceType = '';
    this.invoiceNumber = '';
    this.invoiceNumberV2 = '';
    this.invoiceNumberV3 = '';
    this.vendor = '';
    this.vendorPhone = '';
    this.vendorAddress = '';
    this.reason = '';
    this.tradeType = '';
    this.bankName = '';
    this.bankNumber = '';
    this.chequeNumber = '';
    this.chequeExpireTime = null;
    this.amount = '';
    this.imageURL1 = '';
    this.imageURL2 = '';
    this.imageURL3 = '';
    this.imageURL4 = '';
    this.imageURL5 = '';
    this.createdDate = new Date();
    this.updatedDate = new Date();
    this.applicant = '';
    this.agentId = '';
    this.parentAgentId = '';
    this.flow = 0;
    this.manager = '';
    this.leader = '';
    this.accounting = '';
    this.applyDate = null;
    this.accountType = '';
    this.expectedAmount = 0;
  }
}



// WEBPACK FOOTER //
// ./src/models/CompanyDocModel.js